module.exports = __webpack_public_path__ + "static/media/Pickup.bd47f381.png";